/* eslint-disable */

/**
 * @file Renders Reservations tab in backoffice
 */

import React, { useState, useEffect } from "react";
import axios from "axios";
//import moment from 'moment';
import moment from "moment-timezone";
import styled, { css, createGlobalStyle } from "styled-components";
import Select from "react-select";

import { formatDate, parseDate } from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";

import iconEdit from "../static/icon_editar.svg";
import iconDelete from "../static/icon_lixo.svg";
import iconLeft from "../static/icon_left.svg";
import iconRight from "../static/icon_right.svg";
import iconInfo from "../static/icon_info.png";

import {
  Container,
  Wrapper,
  Section,
  Margin,
  H3,
  H6,
  Text12,
  Loading,
  Checkbox,
} from "../atoms";

import { Modal, Table } from "../molecules";

/**
 * Manages rendering of reservations tab in backoffice
 *
 * @component Reservations
 *
 * @param ...
 * ...
 *
 * CALLED BY:
 * - ...
 *
 * BUGS:
 * - ...
 *
 * TO IMPROVE:
 * @todo Complete @param comments.
 * @todo Review and standardize variable names:
 *   @todo Make sure all internal variables are in english
 *   @todo Decide if database variables should be in English or Portuguese and standardize
 *   @todo Add descriptive comments to all potentially ambiguous variables
 */
export default function Reservations(props) {
  let temp = sessionStorage.getItem("token");

  /**
   * STATE HOOKS
   *
   * TO IMPROVE:
   * @todo Complete comments
   */
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [reservations, setReservations] = useState([]);
  const [bilheteiraId, setBilheteiraId] = useState("");
  const [payments, setPayments] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [dataModal, setDataModal] = useState({});

  const [currentReservations, setCurrentReservations] = useState([]);
  const [pageNumbers, setPageNumbers] = useState([]);
  const [resCount, setResCount] = useState(0); // Total number of reservations for selected service

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(50);

  const [day, setDay] = useState("");
  const [dayEnd, setDayEnd] = useState("");
  const [dataService, setDataService] = useState([]);
  const [service, setService] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const [openSubTable, setOpenSubTable] = useState(false); // Opens row with visitor info
  const [reservationIndex, setReservationIndex] = useState(""); // Sets reservation index to display subtable
  const [tiposBilhete, setTiposBilhete] = useState("");
  const [userData, setUserData] = useState(null); // User database data
  const [user, setUser] = useState("");
  const [userProfile, setUserProfile] = useState("");


  /**
   * OTHER HOOKS
   *
   * TO IMPROVE:
   * @todo Complete comments
   */

  useEffect(() => {
    getCredentials();
    getDate();
    getTiposBilhete(temp);
  }, []);

  useEffect(() => {
    // Set a timer to update debouncedSearch after 400ms of inactivity
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 400);

    // Cleanup timer if search changes before 400ms
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    // Only fetch if debouncedSearch length is 0 (empty) or >= 3
    if (debouncedSearch.length >= 3 || debouncedSearch.length === 0) {
      getReservations(temp, currentPage);
      getService(temp);
    }
  }, [userData, service,  debouncedSearch, day, dayEnd, currentPage, itemPerPage]);

  useEffect(() => {
    getUserData(temp);
  }, [user]);

  useEffect(() => {
    getTicketOfficeData(temp);
  }, [bilheteiraId]);

  useEffect(() => {
    console.log(reservations);
    console.log(currentPage);
    console.log(currentReservations);
    console.log(day);
    console.log(service);
    console.log(resCount);

    setCurrentReservations(reservations);

    console.log(itemPerPage);

    let indexOfLast = currentPage * itemPerPage;
    let indexOfFirst = indexOfLast - itemPerPage;
    let newPageNumbers = [];

    newPageNumbers = Array.from(
      { length: Math.ceil(resCount / itemPerPage) },
      (_, i) => ({ value: i + 1, label: i + 1 }),
    );

    console.log(newPageNumbers);

    setPageNumbers(newPageNumbers);
  }, [reservations, resCount]);

  /**
   * CONSTANTS AND VARIABLES
   *
   * TO IMPROVE:
   * @todo Complete comments
   */

  const BACKEND_DOMAIN = props.BACKEND_DOMAIN;

  let tokenRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let optionsRows = [
    { value: 5, label: "5 items p/page" },
    { value: 10, label: "10 items p/page" },
    { value: 25, label: "25 items p/page" },
    { value: 50, label: "50 items p/page" },
  ];

  //  var pageNumbers = []

  /**
   * HANDLERS / ? CALLBACKS?
   *
   * TO IMPROVE:
   * @todo Complete comments
   */

  /**
   * @callback handleClick - ...
   *
   * CALLED BY:
   * ...
   *
   * TO IMPROVE:
   * ...
   */
  const handleClick = (event) => {
    setCurrentPage(Number(event.target.id));

    console.log(Number(event.target.id));

    getReservations(temp, Number(event.target.id));
  };

  /**
   * FUNCTIONS
   *
   * TO IMPROVE:
   * @todo ? Include setstates in the form of @state in function header comments?
   */


  /**
   * @function getCredentials
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const getCredentials = () => {
    console.log("GET CREDENTIALS");
    console.log(sessionStorage.getItem("bilheteira"));

    setToken(temp);
    setUser(sessionStorage.getItem("username"));
    setUserProfile(sessionStorage.getItem("user-profile"));
    setBilheteiraId(sessionStorage.getItem("bilheteira"));
  };

  /**
   * @function getTiposBilhete
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const getTiposBilhete = (key) => {
    console.log("GET TIPOSBILHETES");

    axios
      .get(BACKEND_DOMAIN + "/tipo-bilhetes" + "?_limit=-1", {
        headers: {
          Authorization: `Bearer ${key}`,
        },
      })
      .then((response) => {
        console.log(response.data);

        setTiposBilhete(response.data);
      })
      .catch((error) => {
        console.log(error);

        setLoading(false);
      });
  };

  /**
   * @function getDate
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const getDate = () => {
    console.log(props.location);

    if (props.location && props.location.data) {
      setDay(props.location.data);
    }
  };

  /**
   * @function getReservations
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const getReservations = (key, page) => {
    if (!userData) return;

    console.log(service);

    setLoading(true);

    const currentPageStart = Math.max(0, (page - 1) * itemPerPage);
    const selectedServiceId = service?.value;

    axios
      .get(BACKEND_DOMAIN + "/reservas", {
        params: {
          userBilheteira: userData.bilheteira.id,
          userServices: userData.servicos.map((s) => s.id),
          _limit: itemPerPage,
          _start: currentPageStart,
          _sort: "created_at:desc",
          service: selectedServiceId || undefined, // will be filtered server-side
          search: debouncedSearch || "", // _q will search in nome/email
          day: day,
          dayEnd: dayEnd,
        },
        headers: {
          Authorization: `Bearer ${key}`,
        },
      })
      .then((response) => {
        console.log(response.data);

        const tempArr = response.data.results;

        tempArr.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        console.log(tempArr);

        const filteredCount = response.data.count;

        setReservations(tempArr);
        setResCount(filteredCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  /**
   * @function getUserData
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const getUserData = (key) => {
    setLoading(true);

    axios
      .get(BACKEND_DOMAIN + "/users/me", {
        headers: {
          Authorization: `Bearer ${key}`,
        },
      })
      .then((response) => {
        console.log(response.data); // Now includes servicos + bilheteira
        setUserData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  /**
   * @function passData
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const passData = (data, type) => {
    setDataModal({
      content: data,
      typeContent: type,
      token: token,
    });

    setTimeout(toogleModal(), 500);
  };

  /**
   * @function toogleModal
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * -
   */
  const toogleModal = () => {
    setIsOpen(!isOpen);
  };

  /**
   * @function getService
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * @todo Create function
   */
  const getService = (key) => {
    if (userData && userData.servicos) {
      setLoading(true);

      axios
        .get(BACKEND_DOMAIN + "/servicos" + "?_limit=-1", {
          headers: {
            Authorization: `Bearer ${key}`,
          },
        })
        .then((response) => {
          let temp = [];

          for (let i = 0; i < response.data.length; i++) {
            temp.push({
              value: response.data[i].id,
              label: response.data[i].nome,
            });
          }

          console.log(temp);
          console.log(userData);

          let filteredTemp = temp.filter((service) => {
            let include = false;

            if (
              userData.servicos.find((s) => s.id == service.value) != undefined
            )
              include =
                service.value ==
                userData.servicos.find((s) => s.id == service.value).id;

            return include;
          });

          console.log(filteredTemp);

          filteredTemp.unshift({
            value: "",
            label: "All",
          });

          setDataService(filteredTemp);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);

          setLoading(false);
        });
    }
  };

  /**
   * @function prevPage
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * ...
   */
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);

      getReservations(temp, currentPage - 1);
    }
  };

  /**
   * @function nextPage
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * ...
   */
  const nextPage = () => {
    if (currentPage < pageNumbers.length) {
      setCurrentPage(currentPage + 1);

      getReservations(temp, currentPage + 1);
    }
  };

  /**
   * @function getTicketOfficeData
   *
   * CALLED BY:
   * -
   *
   * TO IMPROVE:
   * ...
   */
  const getTicketOfficeData = (key) => {
    axios
      .get(BACKEND_DOMAIN + "/bilheteiras/" + bilheteiraId + "?_limit=-1", {
        headers: {
          Authorization: `Bearer ${key}`,
        },
      })
      .then((response) => {
        console.log(response.data);

        setPayments(response.data.Pagamentos);
      });
  };

  console.log("LOADING:", loading);

  return (
    <Section>
      {loading == true && <Loading isLoading={loading} />}
      {loading == false && (
        <Wrapper>
          <Container>
            <DivHeader>
              <H3 font="SFRegular" style={{ fontWeight: "normal" }}>
                Reservations
              </H3>
            </DivHeader>
            <DivFilterAdd>
              <DivGLobalDate>
                <DivDate>
                  <Text12 dangerouslySetInnerHTML={{ __html: "Service" }} />
                  <Margin margin={1} />
                  <Dropdown
                    placeholder="Service"
                    name="slot"
                    classNamePrefix="selectBox"
                    options={dataService}
                    onChange={(selectedOption) => {
                      setCurrentPage(1);
                      setService(selectedOption);
                    }}
                    defaultValue={dataService[0]}
                    value={service}
                  />
                </DivDate>
                <DivDate>
                  <Text12 dangerouslySetInnerHTML={{ __html: "Date" }} />
                  <Margin margin={1} />
                  <InputDate
                    inputProps={{
                      onChange: (e) => {
                        const val = e.target.value;
                        console.log("input onChange:", val);

                        if (!val) {
                          setDay(""); // cleared input, reset state
                          return;
                        }

                        const parsed = moment(val, "DD-MM-YYYY", true);
                        if (parsed.isValid()) {
                          setDay(parsed.format("YYYY-MM-DD")); // valid manual input
                        } else {
                          setDay(""); // invalid input, reset state or keep as ''
                        }
                      },
                      className: "input-date",
                    }}
                    onDayChange={(day) => {
                      console.log("picker onDayChange:", day);
                      if (!day) {
                        setDay(""); // cleared via picker
                      } else if (moment(day).isValid()) {
                        setDay(moment(day).format("YYYY-MM-DD")); // valid pick
                      } else {
                        setDay(""); // fallback invalid date
                      }
                    }}
                    format={"DD-MM-YYYY"}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder="Select date to filter"
                    value={day}
                  />
                </DivDate>
                <DivDate>
                  <Text12 dangerouslySetInnerHTML={{ __html: "Date End" }} />
                  <Margin margin={1} />
                  <InputDate
                    inputProps={{
                      onChange: (e) => {
                        const val = e.target.value;
                        console.log("input onChange:", val);

                        if (!val) {
                          setDayEnd(""); // cleared input, reset state
                          return;
                        }

                        const parsed = moment(val, "DD-MM-YYYY", true);
                        if (parsed.isValid()) {
                          setDayEnd(parsed.format("YYYY-MM-DD")); // valid manual input
                        } else {
                          setDayEnd(""); // invalid input, reset state or keep as ''
                        }
                      },
                      className: "input-date",
                    }}
                    onDayChange={(dayEnd) => {
                      console.log("picker onDayChange:", dayEnd);
                      if (!dayEnd) {
                        setDayEnd(""); // cleared via picker
                      } else if (moment(dayEnd).isValid()) {
                        setDayEnd(moment(dayEnd).format("YYYY-MM-DD")); // valid pick
                      } else {
                        setDayEnd(""); // fallback invalid date
                      }
                    }}
                    format={"DD-MM-YYYY"}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder="Select date to filter"
                    value={dayEnd}
                  />
                </DivDate>
              </DivGLobalDate>
            </DivFilterAdd>
            <Margin margin={2} />
            <DivGLobalDate>
              <DivDate>
                <Text12
                  dangerouslySetInnerHTML={{
                    __html: "Search by Name or Email",
                  }}
                />
                <Margin margin={1} />
                <TextInput
                  onChange={(event) => setSearch(event.target.value)}
                  value={search}
                  placeholder="name or email"
                />
              </DivDate>
              {/*<ButtonSearch onClick={() => getReservations(temp, 0)}>
                Search
              </ButtonSearch>*/}
              <ButtonAdd
                onClick={() => passData("", "addReservation")}
                style={{ marginTop: "24px" }}
              >
                Create New
              </ButtonAdd>
            </DivGLobalDate>
            <Margin margin={4} />
            <DivTabela>
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "center" }}>#id</th>
                    <th style={{ textAlign: "center" }}>Name</th>
                    <th style={{ textAlign: "center" }}>Email</th>
                    <th style={{ textAlign: "center" }}>Date</th>
                    <th style={{ textAlign: "center" }}>Hour</th>
                    <th style={{ textAlign: "center" }}>Quantity</th>
                    <th style={{ textAlign: "center" }}>Phone</th>
                    <th style={{ textAlign: "center" }}>Created at</th>
                    <th style={{ textAlign: "center" }}>Vat</th>
                    <th style={{ textAlign: "center" }}></th>
                  </tr>
                </thead>

                {console.log(currentReservations)}

                {currentReservations.length > 0 && (
                  <>
                    {currentReservations.map((body, index) => (
                      <>
                        <tbody>
                          <tr key={String(index)} style={{ height: "60px" }}>
                            <td className="buttons">
                              <ButtonInfo
                                onClick={() => {
                                  setOpenSubTable(!openSubTable);
                                  setReservationIndex(index);
                                }}
                              >
                                <Icon src={iconInfo} />
                              </ButtonInfo>
                            </td>
                            <td>{body.id}</td>
                            <td
                              style={{
                                textAlign: "left",
                                maxWidth: "220px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {body.nome}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                maxWidth: "220px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {body.email}
                            </td>
                            <td>
                              {moment(body.data).utc().format("YYYY-MM-DD")}
                            </td>
                            <td>{moment(body.data).utc().format("HH:mm")}</td>
                            <td>{body.quantidade}</td>
                            <td>{body.contacto}</td>
                            <td>
                              {moment(body.created_at)
                                .utc()
                                .tz("Europe/Lisbon")
                                .format("YYYY-MM-DD HH:mm")}
                            </td>
                            <td>{body.nif}</td>
                            <td className="buttons">
                              <ButtonEdit
                                onClick={() =>
                                  passData(body, "editReservation")
                                }
                              >
                                <Icon src={iconEdit} />
                              </ButtonEdit>
                              <ButtonDelete
                                onClick={() =>
                                  passData(body, "deleteReservation")
                                }
                              >
                                <Icon src={iconDelete} />
                              </ButtonDelete>
                            </td>
                          </tr>
                        </tbody>
                        {openSubTable == true && index == reservationIndex && (
                          <>
                            <thead style={{ border: "none" }}>
                              <tr>
                                <th></th>
                                <th>Code</th>
                                <th>Country</th>
                                <th>Obs</th>
                                <th>Listen</th>
                                <th>Language</th>
                                <th>Payed</th>
                                <th>Booking Location</th>
                                <th>Payment Location</th>
                                <th>Payment Type</th>
                                <th>Sold By</th>
                              </tr>
                            </thead>
                            <tbody>
                              {console.log("SUBTABLE ELEMENT")}
                              {console.log(body)}
                              {console.log(tiposBilhete)}
                              <tr>
                                <td></td>
                                <td>
                                  {body.codigo && body.codigo?.codigo
                                    ? body.codigo.codigo
                                    : "-"}
                                </td>
                                <td>{body.pais}</td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    maxWidth: "220px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {body.obs}
                                </td>
                                <td>
                                  {body.listen != null ? body.listen : "-"}
                                </td>
                                <td>
                                  {(body.preferredLanguage == "pt" ||
                                    (body.lingua &&
                                      body.lingua.Codigo == "PT") ||
                                    (body.lingua !== undefined &&
                                      body.lingua !== null &&
                                      body.lingua.codigo == "PT")) && (
                                    <div>🇵🇹</div>
                                  )}
                                  {(body.preferredLanguage == "en" ||
                                    (body.lingua &&
                                      body.lingua.Codigo == "EN") ||
                                    (body.lingua !== undefined &&
                                      body.lingua !== null &&
                                      body.lingua.codigo == "EN")) && (
                                    <div>🇬🇧</div>
                                  )}
                                  {(body.preferredLanguage == "fr" ||
                                    (body.lingua &&
                                      body.lingua.Codigo == "FR") ||
                                    (body.lingua !== undefined &&
                                      body.lingua !== null &&
                                      body.lingua.codigo == "FR")) && (
                                    <div>🇫🇷</div>
                                  )}
                                </td>
                                <td>
                                  {body.compra
                                    ? body.compra.status == true && <span> ✅ </span>
                                    : ""}
                                </td>
                                <td>
                                  {body.paymenttype
                                    ? body.paymenttype.bookingLocation
                                    : ""}
                                </td>
                                <td>
                                  {body.paymenttype
                                    ? body.paymenttype.paymentLocation
                                    : ""}
                                </td>
                                <td>
                                  {body.paymenttype
                                    ? body.paymenttype.paymentType
                                    : ""}
                                </td>
                                <td>{body.users ? body.users.username : ""}</td>
                              </tr>
                            </tbody>
                            {body.multiTicket == true && (
                              <>
                                <thead style={{ border: "none" }}>
                                  <tr>
                                    <th></th>
                                    <th>Ticket Type</th>
                                    <th>Quantity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {body.tiposreservas.map((type) => (
                                    <tr>
                                      {console.log(type)}
                                      {console.log(
                                        tiposBilhete.find(
                                          (item) =>
                                            item.id == type.tipo_bilhete,
                                        ),
                                      )}
                                      <td></td>
                                      <td>
                                        {tiposBilhete.find(
                                          (item) =>
                                            item.id == type.tipo_bilhete,
                                        ) != undefined
                                          ? tiposBilhete.find(
                                              (item) =>
                                                item.id == type.tipo_bilhete,
                                            ).tipoBilheteEN
                                          : ""}
                                      </td>
                                      <td>{type.quantidadeTipo}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </>
                )}
              </Table>
            </DivTabela>
            {currentReservations.length === 0 && (
              <H6
                style={{ padding: "40px 0", border: "1px solid #E4EBF0" }}
                font="SFRegular"
                align="center"
                dangerouslySetInnerHTML={{ __html: "No items to display" }}
              />
            )}
            <DivFooter>
              <DropdownItems
                rows={true}
                placeholder="Rows"
                name="rows"
                classNamePrefix="selectBox"
                options={optionsRows}
                onChange={(optionsRows) => setItemPerPage(optionsRows.value)}
                value={
                  optionsRows.filter((data) => data.value === itemPerPage)
                    ? optionsRows.filter((data) => data.value === itemPerPage)
                    : ""
                }
              />
              {pageNumbers.length != 0 && (
                <DivPagination>
                  <Arrow onClick={prevPage} left>
                    <img src={iconLeft} />
                  </Arrow>
                  {console.log(pageNumbers)}
                  {pageNumbers.map((number, index) => (
                    <>
                      {number.value == pageNumbers.length &&
                        currentPage < pageNumbers.length - 2 && (
                          <span style={{ marginRight: "10px" }}>...</span>
                        )}
                      {(number.value == 1 ||
                        number.value == pageNumbers.length ||
                        (number.value >= currentPage - 1 &&
                          number.value <= currentPage + 1)) && (
                        <NumberText
                          key={String(index)}
                          id={number.value}
                          onClick={handleClick}
                          className={
                            currentPage === number.value ? "selected" : ""
                          }
                        >
                          {number.label}
                        </NumberText>
                      )}
                      {number.value == 1 && currentPage > 3 && (
                        <span style={{ marginRight: "10px" }}>...</span>
                      )}
                    </>
                  ))}
                  <Arrow onClick={nextPage} right>
                    <img src={iconRight} />
                  </Arrow>
                </DivPagination>
              )}
            </DivFooter>
          </Container>
          {isOpen && (
            <Modal
              isOpen={isOpen}
              {...dataModal}
              token={token}
              toogleModal={toogleModal}
              reservations={reservations}
              setReservations={setReservations}
              user={user}
              setUser={setUser}
              setUserProfile={setUserProfile}
              userProfile={userProfile}
              dataService={dataService}
              BACKEND_DOMAIN={BACKEND_DOMAIN}
              payments={payments}
            />
          )}
        </Wrapper>
      )}
    </Section>
  );
}

/**
 * @styles
 *
 * TO IMPROVE:
 * -
 */
const DivHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;
const DivFilterAdd = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 1080px) {
    flex-flow: column;
    align-items: flex-start;
  }
`;
const DivGLobalDate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media screen and (max-width: 1080px) {
    flex-direction: column;
  }
`;
const DivDate = styled.div`
  display: flex;
  flex-flow: column;
  margin-right: 20px;
  :last-child {
    margin-right: 00px;
  }
  @media screen and (max-width: 1080px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`;
const InputDate = styled(DayPickerInput)`
  &.input-date {
    height: 48px;
    padding: 16px;
    box-sizing: border-box;
    font-family: SFRegular;
  }
  input {
    height: 48px !important;
    font-family: SFRegular;
  }
`;

const TextInput = styled.input.attrs((props) => ({
  type: "text",
}))`
  font-family: SFMedium;
  padding: 16px 24px;
  border: 1px solid #ebebeb;
  border-radius: 2px;
  width: 450px;
  max-width: 100%;
  height: 48px;
  font-size: 14px;
  line-height: 16px;
  color: #373737;
  box-sizing: border-box;
  transition: all 0.5s ease;
  ::placeholder {
    transition: all 0.5s ease;
    color: #a9a9a9;
  }
  :focus {
    background: #f9f9f9;
    outline: none;
  }
  &.error {
    border-color: #e3000f;
  }
`;
const DivTabela = styled.div`
  width: 100%;
  overflow: scroll;
  height: calc(300px + (650 - 400) * ((100vw - 760px) / (1920 - 760)));
  @media screen and (max-width: 759px) {
    height: 350px;
  }
`;

const Icon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 8px;
  z-index: 10;
`;
const ButtonAdd = styled.div`
  background: #ffce20;
  border-radius: 2px;
  padding: 16px 55px;
  margin-left: auto;
  display: flex;
  align-items: center;
  align-self: flex-end; /* Align to bottom of input */
  justify-content: center;
  font-family: SFRegular;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #373737;
  transition: all 0.4s ease;
  height: 48px;
  box-sizing: border-box;
  :hover {
    background: #f8c100;
    cursor: pointer;
  }
  @media screen and (max-width: 1080px) {
    padding: 16px 30px !important;
    margin-right: auto !important;
    margin-left: 0;
  }
`;

const ButtonSearch = styled.div`
  width: 126px;
  background: #ffce20;
  border-radius: 2px;
  padding: 16px 55px;
  margin-left: 0;
  margin-right: "auto";
  display: flex;
  align-items: center;
  align-self: flex-end; /* Align to bottom of input */
  justify-content: center;
  font-family: SFRegular;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #373737;
  transition: all 0.4s ease;
  height: 48px;
  box-sizing: border-box;
  :hover {
    background: #f8c100;
    cursor: pointer;
  }
  @media screen and (max-width: 1080px) {
    padding: 16px 30px !important;
    margin-right: auto !important;
    margin-left: 0;
    margin-bottom: 16px;
  }
`;

const ButtonEdit = styled.div`
  background: #ffce20;
  border-radius: 2px;
  padding: 8px 0px 8px 10px;
  display: flex;
  align-items: center;
  :center;
  justify-content: center;
  font-family: SFRegular;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #373737;
  transition: all 0.4s ease;
  max-height: 14px;
  :hover {
    background: #f8c100;
    cursor: pointer;
  }
`;
const ButtonInfo = styled.div`
  margin-left: 5px;
  background: #63666a;
  border-radius: 2px;
  padding: 8px 2px 8px 10px;
  display: flex;
  align-items: center;
  :center;
  justify-content: center;
  font-family: SFRegular;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #373737;
  transition: all 0.4s ease;
  max-height: 14px;
  :hover {
    background: #393d47;
    cursor: pointer;
  }
`;
const ButtonDelete = styled.div`
  margin-left: 5px;
  background: #ebebeb;
  border-radius: 2px;
  padding: 8px 2px 8px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SFRegular;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #373737;
  transition: all 0.4s ease;
  max-height: 14px;
  :hover {
    background: #a9a9a9;
    cursor: pointer;
  }
`;
const DivPagination = styled.div`
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 50px;
  flex-wrap: wrap;
`;
const NumberText = styled.div`
  height: 48px;
  width: 48px;
  margin-right: 10px;
  margin-top: 10px;
  background: #ebebeb;
  border: 1px solid #ebebeb;
  color: #a9a9a9;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.4s ease;
  &.selected {
    color: #373737;
    background: #ffce20;
  }
  :last-of-type {
    margin-right: 0;
  }
  :hover {
    cursor: pointer;
    color: #373737;
    border: 1px solid #a9a9a9;
  }
`;
const Arrow = styled.div`
  height: 48px;
  width: 48px;
  border: 1px solid #ebebeb;
  background: #ebebeb;
  box-sizing: border-box;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  color: #a9a9a9;
  transition: all 0.4s ease;
  ${({ left }) =>
    left &&
    css`
      margin-right: 10px;
    `}
  ${({ right }) =>
    right &&
    css`
      margin-right: 10px;
    `}
  :hover {
    cursor: pointer;
    border: 1px solid #a9a9a9;
    color: #373737;
  }
`;
const Dropdown = styled(Select)`
  width: 250px;
  font-family: SFMedium;
  margin-bottom: ${({ rows }) => (rows ? "0" : "16px")};
  margin-right: ${({ rows }) => (rows ? "16px" : "0")};
  div {
    border-color: #e4ebf0;
    min-height: 36px;
  }
  .selectBox__control {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #4e5d6b;
    box-sizing: border-box;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    height: 48px;
    .selectBox__value-container {
      border-radius: 0;
      align-items: center;
      padding: 16px 24px;
      box-sizing: border-box;
      height: 48px;
      .selectBox__input {
        display: flex !important;
        align-items: center !important;
      }
      .selectBox__single-value {
        display: flex;
        align-items: center;
      }
      .selectBox__placeholder {
        display: flex;
        align-items: center;
      }
    }
    .selectBox__indicators {
      height: 48px;
      width: 48px;
      background: #f5f7f7;
      justify-content: center;
      .selectBox__indicator-separator {
        display: none;
      }
      .selectBox__dropdown-indicator {
        display: flex;
        align-items: center;
        svg {
          transition: all 400ms ease;
          transform: rotate(0);
        }
      }
      &:hover {
        background-color: #e4ebf0;
      }
    }
    :hover {
      border-color: #ebebeb;
    }
  }
  .selectBox__menu {
    border-radius: 0;
    margin-top: 4px;
    box-sizing: border-box;
    box-shadow: none;
    border: 1px solid #d8d8d8;
    z-index: 2;
    .selectBox__menu-list {
      background: #fff !important;
      margin: 0;
      .selectBox__option {
        font-size: 14px;
        display: flex;
        align-items: center;
        &.selectBox__option--is-selected {
          background-color: #d8d8d8;
          color: #000;
        }
        &.selectBox__option--is-focused {
          background-color: #eaeaea;
          color: #000;
        }
        &:hover {
          cursor: pointer;
          background: #e4ebf0;
        }
      }
    }
  }
  .selectBox__control--is-focused {
    border-width: 1px;
    border-style: solid;
    border-color: #f5f7f7;
    box-shadow: none;
    &:hover {
      border-color: #f5f7f7;
    }
  }
  .selectBox__control--menu-is-open {
    .selectBox__indicators {
      .selectBox__dropdown-indicator {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }
  @media screen and (max-width: 570px) {
    margin-bottom: ${({ rows }) => (rows ? "0" : "16px")};
  }
`;
const DropdownItems = styled(Select)`
  width: 250px;
  min-width: 200px;
  font-family: SFMedium;
  margin-bottom: ${({ rows }) => (rows ? "0" : "16px")};
  margin-right: ${({ rows }) => (rows ? "16px" : "0")};
  div {
    border-color: #e4ebf0;
    min-height: 16px;
  }
  .selectBox__control {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #4e5d6b;
    box-sizing: border-box;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    height: 48px;
    .selectBox__value-container {
      border-radius: 0;
      align-items: center;
      padding: 16px 24px;
      box-sizing: border-box;
      height: 48px;
      .selectBox__input {
        display: flex !important;
        align-items: center !important;
      }
      .selectBox__single-value {
        display: flex;
        align-items: center;
      }
      .selectBox__placeholder {
        display: flex;
        align-items: center;
      }
    }
    .selectBox__indicators {
      height: 48px;
      width: 48px;
      background: #f5f7f7;
      justify-content: center;
      .selectBox__indicator-separator {
        display: none;
      }
      .selectBox__dropdown-indicator {
        display: flex;
        align-items: center;
        svg {
          transition: all 400ms ease;
          transform: rotate(0);
        }
      }
      &:hover {
        background-color: #e4ebf0;
      }
    }
    :hover {
      border-color: #ebebeb;
    }
  }
  .selectBox__menu {
    border-radius: 0;
    margin-top: 4px;
    box-sizing: border-box;
    box-shadow: none;
    border: 1px solid #d8d8d8;
    z-index: 2;
    top: -160px;
    .selectBox__menu-list {
      background: #fff !important;
      margin: 0;
      .selectBox__option {
        font-size: 14px;
        display: flex;
        align-items: center;
        min-height: 36px;
        &.selectBox__option--is-selected {
          background-color: #d8d8d8;
          color: #000;
        }
        &.selectBox__option--is-focused {
          background-color: #eaeaea;
          color: #000;
        }
        &:hover {
          cursor: pointer;
          background: #e4ebf0;
        }
      }
    }
  }
  .selectBox__control--is-focused {
    border-width: 1px;
    border-style: solid;
    border-color: #f5f7f7;
    box-shadow: none;
    &:hover {
      border-color: #f5f7f7;
    }
  }
  .selectBox__control--menu-is-open {
    .selectBox__indicators {
      .selectBox__dropdown-indicator {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }
  @media screen and (max-width: 570px) {
    margin-bottom: ${({ rows }) => (rows ? "0" : "16px")};
  }
`;
const DivFooter = styled.div`
  display: flex;
  flex-flow: row;
  margin-top: 14px;
`;
const DivCheckbox = styled.div`
  max-width: 78px;
  display: flex;
  flex-flow: row;
  align-items: center;
  padding: 8px 17px;
  box-sizing: border-box;
  background: #ebebeb;
  box-sizing: border-box;
  border-radius: 2px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #a9a9a9;
  :hover {
    background: #f8c100;
    cursor: pointer;
  }
  ${({ checked }) =>
    checked &&
    css`
      background: #ffce20;
      color: #373737;
    `}
`;
